export const devToolsEnabled = process.env.DEV_TOOLS === 'true';
